import TopSection from "../components/topSection";
import BG from "../assets/shop_bg.png";
import { useEffect, useMemo, useState } from "react";
import "../styles/shop.css";
import { getData } from "../api";
import { useCart } from "../CartContext";

const CATEGORIES = ["ALL", "BOOKS", "DIGITAL MAGAZINES"];

const formatLKR = (n) => {
  const num = Number(n);
  return Number.isFinite(num)
    ? `Rs. ${num.toLocaleString("en-LK", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : "Rs. —";
};

function Shop({ onAddToCart }) {
  const [active, setActive] = useState("ALL");
  const [products, setProducts] = useState([]);          // keep as array
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
const { addToCart } = useCart();
  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const res = await getData("products?page=1&limit=10&sort=-createdAt,name");

        // Normalize various possible shapes into an array
       const list =
        Array.isArray(res?.items)  ? res.items  :
        Array.isArray(res?.result) ? res.result :
        Array.isArray(res?.data)   ? res.data   :
        Array.isArray(res)         ? res        :
        [];

        if (isMounted) setProducts(list);
      } catch (e) {
        console.error("Error fetching products:", e);
        if (isMounted) setErr("Failed to load products.");
      } finally {
        if (isMounted) setLoading(false);
      }
    })();

    return () => { isMounted = false; };
  }, []);

  const filtered = useMemo(() => {
    if (active === "ALL") return products ?? [];
    // Only filter if items have a category; otherwise just return all
    return (products ?? []).filter(p => (p.category || "BOOKS") === active);
  }, [products, active]);

  return (
    <>
      <TopSection text="Shop" image={BG} backgroundPositionY={"0%"} />
      <div className="catalog">
        {/* Tabs */}
        <nav className="catalog__tabs" aria-label="Categories">
          {CATEGORIES.map((tab) => (
            <button
              key={tab}
              type="button"
              className={`catalog__tab ${active === tab ? "is-active" : ""}`}
              onClick={() => setActive(tab)}
              aria-pressed={active === tab}
            >
              {tab}
            </button>
          ))}
        </nav>

        {/* States */}
        {loading && <p className="mt-5">Loading products…</p>}
        {err && !loading && <p className="mt-5" role="alert">{err}</p>}
        {!loading && !err && filtered.length === 0 && (
          <p className="mt-5">No products found.</p>
        )}

        {/* Grid */}
        {!loading && !err && filtered.length > 0 && (
          <section className="catalog__grid mt-5">
            {(filtered ?? []).map((p) => {
              const imgSrc = p.images[1] || 'https://via.placeholder.com/150x220?text=No+Image';
              return (
                <article key={p.id || p._id || crypto.randomUUID()} className="card">
                  <div className="card__thumb">
                    <img
                      src={imgSrc}
                      alt={`${p.title || "Untitled"} cover`}
                      loading="lazy"
                    />
                  </div>

                  <div className="card__meta">
                    <h3 className="card__title">{p.name || "Untitled"}</h3>
                    <p className="card__author">{p.description || "—"}</p>
                    <p className="card__price">{formatLKR(p.price)}</p>
                  </div>

                  <button
                    className="card__cta disabled"
                    // onClick={() => ( addToCart(p) )}
                  >
                    Add To Cart
                  </button>
                </article>
              );
            })}
          </section>
        )}
      </div>
    </>
  );
}

export default Shop;
